import { of as observableOf, Observable, throwError } from 'rxjs';
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { TokenService } from "../../services/shared/token.service";
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import swal from 'sweetalert';
import { Environment } from '@env/environment.global';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  constructor(private router: Router, private tokenService: TokenService, public environment: Environment) { }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    if (err.status === 401 || err.status === 403) {

      if (err.error && err.error.Error && err.error.Error === 'SessionForcefullyClosed') {
        swal({
          title: 'Session closed',
          text: 'Your session is forcefully closed by another user!',
          icon: 'warning',
          buttons: {
            cancel: false,
            confirm: {
              text: 'Ok!',
              value: true,
              visible: true,
              className: 'bg-danger',
              closeModal: true
            }
          }
        });
      }

      this.tokenService.clear();
      this.router.navigateByUrl(`/login`);
      return observableOf(err.message);
    }

    return throwError(err);
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler) {
    var url = request.url;
    if (request.url.startsWith('assets/') === false) {
      url = !request.url.startsWith('http') ? this.environment.getBaseUrl() + request.url : request.url;

      if (!url.includes("http")) {
        url = document.getElementsByTagName("base").item?.(0)?.href + url;
      }
    } else {
      url = document.getElementsByTagName("base").item?.(0)?.href + url;
    }

    if (request &&
      (request.url.indexOf('upload-file') > -1 ||
        request.url.indexOf('upload-image') > -1 ||
        request.url.indexOf('upload-editor-image') > -1 ||
        request.url.indexOf('LoadPdf') > -1 ||
        request.url.indexOf('UploadDataSheet') > -1 ||
        request.url.indexOf('UploadBackgroundImage') > -1 ||
        request.url.indexOf('GenerateDeepZoomImagesWithImage') > -1 ||
        request.url.indexOf('useradministration') > -1)) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.tokenService.get('token')}`
        },
        url
      });

      return next.handle(request);
    } else {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.tokenService.get('token')}`,
          'Content-Type': 'application/json; charset=utf-8'
        },
        url
      });
    }

    return next.handle(request).pipe(catchError(x => this.handleAuthError(x)));
  }
}
